import 'jquery'

export default class MailTemplateSample {

    constructor() {
      this.value_check();
    }

    value_check() {
        var self = this
        jQuery("#message_template_sample").change(function(){
            var pre_message_template_body = $("#message_template_body").val();
            var selected_val = $("#message_template_sample").val();

            if (selected_val !== "default"){
                if (pre_message_template_body.length < 1) {
                    $("#message_template_body").val(gon.views.companytools.message_template_sample[selected_val]);
                } else {
                    self.confirmation_check(selected_val)
                }
            }
        });
    }

    confirmation_check(selected_val) {
        var result = window.confirm(gon.views.companytools.message_template_sample.overwrite_caution);
        if( result ) {
            $("#message_template_body").val(gon.views.companytools.message_template_sample[selected_val]);
        } else {
            $("#message_template_sample").val(pre_message_template_sample)
            $("#message_template_body").val(pre_message_template_body)
        }
        return
    }
}